<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="80px"
      :model="formLabelAlign"
    >
      <el-form-item label="名称">
        <el-input v-model="formLabelAlign.title"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbitrew"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { videoSettingupdateVideo } from '@/api/sourceminiprogram.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        title: ''
      },
      id: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(item) {
      console.log('item', item)
      this.formLabelAlign.title = item.title
      this.id = item.id
    },
    async sumbitrew() {
      if (this.formLabelAlign.title === '') {
        this.$message.error('请填写标题')
        return
      }
      const data = await videoSettingupdateVideo({ title: this.formLabelAlign.title, id: this.id })
      this.$emit('updataedit')
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>